import { render, staticRenderFns } from "./myLeaveShow.vue?vue&type=template&id=68fe6333&scoped=true"
import script from "./myLeaveShow.vue?vue&type=script&lang=js"
export * from "./myLeaveShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68fe6333",
  null
  
)

export default component.exports